import React, { useRef, useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from "primereact/inputnumber";
import { useHistory, useParams } from "react-router-dom";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ErrorValidationMessage } from './ErrorValidationMessage';
import { BrCalendar } from './BrCalendar';

import api from '../api/api';

import '../layout/sass/_form.scss';

export const FormEstacionamento = ({ isEditing, isLoading }) => {

    const history = useHistory();
    const { id } = useParams();
    const toast = useRef(null);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [pessoas, setPessoas] = useState(null);
    const [veiculos, setVeiculos] = useState(null);
   
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);    
    

    const schema = Yup.object().shape({
        data: Yup
            .date()
            .typeError("Uma data deve ser inserida")
            .required("A data é obrigatória"),
        placa: Yup
            .string()
            .required("A placa é obrigatório")
            .max(200, "A placa dete ter no máximo 200 caracteres"),        
        valor: Yup
            .string()
            .required("O valor é obrigatório")
            .max(10, "O valor dete ter no máximo 10 caracteres"),
        divida: Yup
            .number()
            .required("A divida é obrigatório"),
        pessoaId: Yup
            .number()
            .required("A pessoa é obrigatório")
            .positive("A pessoa deve ser selecionada")
            .integer("A pessoa deve estar na lista"),
        veiculoTipoId: Yup
            .number()
            .required("O tipo de veiculo é obrigatório")
            .positive("O tipo de veiculo deve ser selecionado")
            .integer("O tipo de veiculo deve estar na lista")
        
    })


    function dividaHandleOnBlur(e) {

        if (e.target.value > 0) {

            api.get(`estacionamento/divida/${e.target.value}`).then((response) => {
                var divida = response.data;
                if (divida.valorPgto > 0) {
                    toast.current.show({ life: 4000, severity: 'success', summary: 'Dívida!', detail: `Contribuinte: ${divida.nomeContribuinte} Valor: ${divida.valorPgto}` });
                } else {
                    toast.current.show({ life: 4000, severity: 'warn', summary: 'Dívida!', detail: `Contribuinte: ${divida.nomeContribuinte} Valor: ${divida.valorPgto}` });
                }

            }).catch((error) => {
                toast.current.show({ life: 4000, severity: 'error', summary: 'Dívida!', detail: "Dívida não encontrada..." });
            });
        }
    }

  
     
    const formik = useFormik({
        initialValues: {
            "id": 0,
            "placa": "",
            "valor": "",
            "divida": "",
            "pessoaId": 0,            
            "pessoaNome": "",
            "data": "",
            "veiculoTipoId": 0,
            "tipoVeiculoNome": ""
        },


        validationSchema: schema,

        enableReinitialize: true,

        onSubmit: async (data) => {
            setIsSubmiting(true)
         

            await api.post("estacionamento", data)

  
         
            try {
                if (!isEditing) {

                    formik.resetForm()
                    toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro concluído!', detail: `${data.placa} adicionado(a) com sucesso` });
                    setTimeout(() => {
                        history.push('/estacionamento')

                    }, 2000)

                }
                else {

                    await api.put("estacionamento", data)

                    toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro atualizado!', detail: `${data.placa} atualizado(a) com sucesso` });
                    setTimeout(() => {

                        history.push('/estacionamento')

                    }, 2000)
                }
            }
            catch (error) {
                if (!isEditing)
                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao cadastrar estacionamento!', detail: error.toString() });
                else
                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao editar estacionamento!', detail: error.toString() });

            }

            setIsSubmiting(false)
        }
    })

     
    useEffect(() => {
        if (isEditing) {
            api.get(`estacionamento/${id}`).then((response) => formik.setValues(response.data));
        }
        api.get("pessoa").then((response) => setPessoas(response.data.content));  
        api.get("veiculo_tipo").then((response) => setVeiculos(response.data));     
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
   
    return (
        <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
            <Toast ref={toast} position="top-right" />
            <div className="p-col-12">
                <h2 className="p-mt-0">Estacionamento</h2>
                <form onSubmit={formik.handleSubmit}>
                    <div className="p-formgrid p-grid p-fluid p-mx-0">

                        <div className="p-field p-col-12 p-sm-4 p-md-2">
                            <label
                                htmlFor="data"
                                className={classNames({ 'p-error': isFormFieldValid('data') })}
                            >
                                Data
                            </label>
                            {
                                !isLoading ?
                                    <BrCalendar
                                        id="data"
                                        name="data"
                                        value={new Date(formik.values.data).toLocaleDateString()}
                                        onChange={formik.handleChange}
                                        placeholder={ isEditing === true ? new Date(formik.values.data).toLocaleDateString() : ""}
                                        readonly={true}
                                        className={classNames({ 'p-invalid': isFormFieldValid('data') })}
                                        yearRange={`2000:${new Date().getFullYear()}`}
                                    />
                                    :
                                    <Skeleton height="35px" />
                            }
                           
                            {formik.errors.data && formik.touched.data &&
                                <ErrorValidationMessage message={formik.errors.data} />
                            }
                        </div>

                        <div className="p-field p-col-12 p-sm-2">
                            <label
                                htmlFor="placa"
                                className={classNames({ 'p-error': isFormFieldValid('placa') })}
                            >
                                Placa
                            </label>
                            {
                                !isLoading ?
                                    <InputText
                                        id="placa"
                                        name="placa"
                                        className={classNames({ 'p-invalid': isFormFieldValid('placa') })}
                                        value={formik.values.placa}
                                        onChange={formik.handleChange}
                                    />
                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.placa && formik.touched.placa &&
                                <ErrorValidationMessage message={formik.errors.placa} />
                            }
                        </div>

                        <div className="p-field p-col-12 p-sm-2">
                            <label
                                htmlFor="valor"
                                className={classNames({ 'p-error': isFormFieldValid('valor') })}
                            >
                                Valor
                            </label>
                            {
                                !isLoading ?
                                    <InputNumber
                                        id="valor"
                                        name="valor"
                                        mode="currency" minFractionDigits={2} 
                                        currency="BRL"
                                        className={classNames({ 'p-invalid': isFormFieldValid('valor') })}
                                    locale="pt-BR"
                                   value={formik.values.valor}
                                   onChange={(e) => formik.setFieldValue("valor", e.value)}  
                                    />
                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.valor && formik.touched.valor &&
                                <ErrorValidationMessage message={formik.errors.valor} />
                            }                            
                        </div>


                        <div className="p-field p-col-12 p-sm-2">
                            <label
                                htmlFor="divida"
                                className={classNames({ 'p-error': isFormFieldValid('divida') })}
                            >
                                Divida
                            </label>
                            {
                                !isLoading ?
                                    <InputText
                                        id="divida"
                                        name="divida"
                                        type="number"
                                        className={classNames({ 'p-invalid': isFormFieldValid('divida') })}
                                        value={formik.values.divida}
                                        onChange={formik.handleChange}
                                        onBlur={dividaHandleOnBlur}
                                    />
                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.divida && formik.touched.divida &&
                                <ErrorValidationMessage message={formik.errors.divida} />
                            }                            
                        </div>


                        <div className="p-field p-col-12 p-sm-2">
                            <label
                                htmlFor="pessoa"
                                className={classNames({ 'p-error': isFormFieldValid('pessoa') })}
                            >
                                Pessoa
                            </label>
                            {
                                !isLoading ?
                                <Dropdown
                                    id="pessoaId"
                                    name="pessoaId"
                                    options={pessoas}
                                    filter={true}
                                    emptyMessage={"Nenhuma pessoa encontrada"}
                                    optionLabel="nome"
                                    optionValue="id"
                                    placeholder="Selecione uma pessoa"
                                    className={classNames({ 'p-invalid': isFormFieldValid('pessoaId') })}
                                    value={formik.values.pessoaId}
                                    onChange={option => formik.setFieldValue("pessoaId", option.value)}
                                    emptyFilterMessage={"Nenhuma pessoa encontrada"}
                                    disabled={pessoas === ''}
                                />
                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.pessoaId && formik.touched.pessoaId &&
                                <ErrorValidationMessage message={formik.errors.pessoaId} />
                            }
                        </div>

                        <div className="p-field p-col-12 p-sm-2">
                            <label
                                htmlFor="veiculo"
                                className={classNames({ 'p-error': isFormFieldValid('veiculo') })}
                            >
                                Tipo de Veiculo
                            </label>
                            {
                                !isLoading ?
                                    <>
                                        <Dropdown
                                            id="veiculoTipoId"
                                            name="veiculoTipoId"
                                            options={veiculos}
                                            filter={true}
                                            emptyMessage={"Nenhum tipo veiculo encontrado"}
                                            optionLabel="nome"
                                            optionValue="id"
                                            placeholder="Selecione um tipo veiculo"
                                            className={classNames({ 'p-invalid': isFormFieldValid('veiculoTipoId') })}
                                            value={formik.values.veiculoTipoId}
                                            onChange={option => formik.setFieldValue("veiculoTipoId", option.value)}
                                            emptyFilterMessage={"Nenhum tipo veiculo encontrado"}
                                            disabled={formik.values.veiculos === ''}
                                        />
                                        
                                                                    </>
                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.veiculoTipoId && formik.touched.veiculoTipoId &&
                                <ErrorValidationMessage message={formik.errors.veiculoTipoId} />
                            }
                        </div>
                        
                        
                    </div>
                    <div className="p-d-flex p-jc-end p-mr-1">
                        {
                            !isLoading ?
                                <Button
                                    label={isEditing ? 'Atualizar' : 'Salvar'}
                                    type="submit"
                                    iconPos="right"
                                    loading={isSubmiting}
                                />
                                :
                                <Skeleton width="82.16px" height="35px" />
                                
                        }
                    </div>
                </form>
            </div>
        </div>

    );
}
